import { render, staticRenderFns } from "./singleCarddailishang.vue?vue&type=template&id=a20e3d94"
import script from "./singleCarddailishang.vue?vue&type=script&lang=js"
export * from "./singleCarddailishang.vue?vue&type=script&lang=js"
import style0 from "./singleCarddailishang.vue?vue&type=style&index=0&id=a20e3d94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_35e1b9026555e837868613c3c720eb09/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports